import { useAppSelector } from '../../../../store';
import { Task } from '../../../../entities/task/model/types/tasks';

export const useTaskAuthor = (taskId: string) => {
    const taskData: Task = useAppSelector((state) => state.tasksReducer.entities[taskId]);
    const { employees } = useAppSelector((state) => state.tasksInformationReducer);
    if (!taskId) {
        return { name: '', id: '' };
    }

    const authorInfo = employees.filter((author) => {
        return taskData?.involved?.author_id === author.id;
    })[0];
    return { authorInfo };
};
